import api from '@/store/api/reservation/actions-logs'
import * as mutationTypes from './mutation-types'
// Modules
import {mapLegacyPagination} from '@/store/utils'

const initialState = () => ({
    actionsLogs: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        actionsLogs: state => state.actionsLogs.data,
        pagination: state => state.actionsLogs.pagination
    },
    actions: {
        listActionsLogs: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listActionsLogs(data)
                const actionsLogs = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }

                commit(mutationTypes.SET_ACTIONS_LOGS, actionsLogs)
                return actionsLogs
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetActionsLogs: async ({commit}) => commit(mutationTypes.RESET_ACTIONS_LOGS)
    },
    mutations: {
        [mutationTypes.SET_ACTIONS_LOGS]: (state, data) => state.actionsLogs = data,
        [mutationTypes.RESET_ACTIONS_LOGS]: (state) => Object.assign(state, initialState())
    }
}
